// extracted by mini-css-extract-plugin
export default {"img":"styles_img__BRktC","text":"styles_text__x0IHC"};